import useReduxState from '@portal/hooks/useReduxState';
import { translate } from '@portal/services/i18n';
import { Select, Row, Col } from 'antd';
import React, { useEffect } from 'react';
import AdvancedInput from '@portal/components/AdvancedInput/AdvancedInput';

import { BankActions } from '@portal/actions';
import { useDispatch } from 'react-redux';
import { removeAccent } from '@portal/services/masks';
import { DefaultOptionType } from 'antd/lib/select';

type BankDataFormProps = {
  bankAgency: string | null;
  setBankAgency?: (value: string) => void;
  bankAccount: string | null;
  setBankAccount?: (value: string) => void;
  bankAccountDigit: string | null;
  setBankAccountDigit?: (value: string) => void;
  bankCode: string | null;
  setBankCode?: (value: string) => void;
};

const BankDataForm = ({
  bankAgency,
  setBankAgency,
  bankAccount,
  setBankAccount,
  bankAccountDigit,
  setBankAccountDigit,
  bankCode,
  setBankCode,
}: BankDataFormProps) => {
  const dispatch = useDispatch();
  const {
    bank: { list: banks },
  } = useReduxState();

  const filterOption = (input: string, option?: DefaultOptionType) =>
    removeAccent(option?.children ? option.children.toString() : '')
      .toLowerCase()
      .indexOf(removeAccent(input).toLowerCase()) >= 0;

  const handleBankSelected = (value: string) => {
    if (!setBankCode || !banks) {
      return;
    }

    const selectedBank = banks.find((bank) => bank.code === value);
    if (selectedBank) {
      setBankCode(value);
    } else {
      setBankCode('');
    }
  };

  useEffect(() => {
    dispatch(BankActions.getBanks());
  }, [dispatch]);

  return (
    <div className="bank-data-form">
      <h1 className="loan-external-simulation__title">
        {translate('PAGES.LOAN.SIMULATE.BANK_DATA.ACCOUNT_DATA')}
      </h1>
      <h2 className="loan-external-simulation__subtitle">
        {translate('PAGES.LOAN.SIMULATE.BANK_DATA.EXPLANATION')}
      </h2>

      <Row>
        <Col>
          <Select
            className="bank-data-form__input__select"
            showSearch
            allowClear
            bordered={false}
            placeholder={translate('PAGES.LOAN.SIMULATE.BANK_DATA.BANK')}
            filterOption={filterOption}
            onChange={handleBankSelected}
            value={bankCode || null}
          >
            {banks?.map(
              (bank) =>
                bank.code && (
                  <Select.Option value={bank.code} key={bank.code}>
                    {bank.code} - {bank.name}
                  </Select.Option>
                )
            )}
          </Select>
        </Col>
      </Row>

      <Row>
        <Col>
          <AdvancedInput
            variant="standard"
            label={translate('PAGES.LOAN.SIMULATE.BANK_DATA.AGENCY')}
            maxLength={4}
            value={bankAgency}
            onChange={setBankAgency}
          />
        </Col>
        <Col>
          <AdvancedInput
            variant="standard"
            label={translate('PAGES.LOAN.SIMULATE.BANK_DATA.ACCOUNT')}
            maxLength={20}
            value={bankAccount}
            onChange={setBankAccount}
          />
        </Col>
        <Col>
          <AdvancedInput
            variant="standard"
            label={translate('PAGES.LOAN.SIMULATE.BANK_DATA.DIGIT')}
            maxLength={1}
            value={bankAccountDigit}
            onChange={setBankAccountDigit}
          />
        </Col>
      </Row>
    </div>
  );
};

export default BankDataForm;
